<template>
  <b-modal
    modal-class="modal-fullscreen"
    @shown="onModalShown"
    id="upload-image"
    ref="upload-image"
    header-class="d-flex align-items-center">
    <template #modal-header="{ close }">
      <div class="d-flex align-items-center flex-grow-1">
        <div class="pr-3 cursor-pointer">
          <i class="ni ni-bold-left" @click="close()"></i>
        </div>
        <div class="h3 mb-0 flex-grow-1 text-center">
          {{ upload.title }}
        </div>
      </div>
    </template>
    <b-row>
      <b-col cols="4" lg="3" class="px-0">
        <div
          class="btn-upload-image d-flex justify-content-center align-items-center cursor-pointer"
          @click="triggerFileInput()">
          <b-icon icon="camera" font-scale="2"></b-icon>
        </div>
        <b-form-file
          multiple
          ref="refInputImage"
          accept=".jpeg,.png,.jpg"
          class="display-none"
          @change="uploadImage($event)"
        >
        </b-form-file>
      </b-col>
      <b-col
        cols="4"
        lg="3"
        v-for="(image, index) in route
          ? route.jobImages[upload.type].image
          : []"
        :key="index"
        class="mb-1 px-1 position-relative"
        @click="selectedImage(image)">
        <img
          :src="image.preview ? image.preview : image.key"
          :alt="`image_${index}`"
          :class="[
            'image-max-size',
            checkSelected(image.number) && 'image-active',
          ]" />
        <div
          v-if="checkSelected(image.number)"
          :class="{ 'image-icon-active': checkSelected(image.number) }">
          <b-icon icon="check-square-fill" class="text-primary"></b-icon>
        </div>
      </b-col>
    </b-row>
    <template #modal-footer>
      <div class="w-100">
        <b-button
          variant="primary"
          class="float-right m-1"
          pill
          :disabled="selected.length === 0 || checkImage"
          @click="confirmSelected()"
        >
          อัพโหลด
        </b-button>
        <b-button
          variant="danger"
          class="float-right m-1"
          pill
          :disabled="selected.length === 0"
          @click="showConfirmDeleteModal">
          ลบ
        </b-button>
      </div>
    </template>
  </b-modal>
</template>

<script>
import { STATUS_SUCCESS } from "@/util/constants.js" 
import { modalSuccess, modalError } from '@/util/alert.js'

export default {
  props: {
    upload: {
      type: Object,
    },
    route: {
      type: Object,
      default: () => {
        jobImages: {}
      },
    },
  },
  data() {
    return {
      selected: [],
    };
  },
  methods: {
    onModalShown() {
      console.log("onModalShown");
    },
    checkSelected(number) {
      if(this.route.status === STATUS_SUCCESS){
        return false
      }
      return this.selected.some((select) => select.number === number);
    },
    triggerFileInput() {
      if(this.route.status === STATUS_SUCCESS){
        return false
      }

      this.$refs.refInputImage.$el.querySelector("input").click();
    },
    uploadImage(e) {
      if (e.target.files.length < 1) return false;
      let SELF = this;
      Array.from(e.target.files).forEach((image) => {
        const fileReader = new FileReader();
        fileReader.readAsDataURL(image);
        fileReader.onload = () => {
          if (typeof fileReader.result === "string") {
            let imageData = {
              number: SELF.route.jobImages[this.upload.type].number++,
              file: image,
              preview: fileReader.result,
            }

            SELF.route.jobImages[this.upload.type].image.push(imageData);
            // auto selected image all
            SELF.selected.push(imageData)
          }
        };
      });
    },
    selectedImage(image) {
      if(this.route.status === STATUS_SUCCESS){
        return false
      }

      const indexOfItem = this.selected.findIndex((item) => {
        return item.number === image.number;
      });
      if (indexOfItem > -1) {
        this.selected.splice(indexOfItem, 1);
      } else {
        this.selected.push(image);
      }
    },
    confirmSelected() {
      //   this.route.jobImages[this.upload.type].selected = this.selected;
      const jobImages = this.route.jobImages[this.upload.type].image;

      this.$emit("images-uploaded", {
        type: this.upload.type,
        images: jobImages,
        route_id: this.route.id,
      });
      
      this.hideModal();
    },
    showConfirmDeleteModal() {
      this.$bvModal
        .msgBoxConfirm("คุณแน่ใจว่าต้องการลบภาพที่เลือกหรือไม่?", {
          title: "ยืนยันการลบ",
          okTitle: "ใช่",
          cancelTitle: "ไม่ใช่",
          centered: true,
        })
        .then((confirmed) => {
          if (confirmed) {
            this.confirmDeleteImages();
          }
        })
        .catch((err) => {
          console.error("Modal dismissed: ", err);
        });
    },
    confirmDeleteImages() {
      const imagesToDelete = [];
      this.selected.forEach((image) => {
        if (image.id) {
          imagesToDelete.push(image.id);
        }
        const index = this.route.jobImages[this.upload.type].image.findIndex(
          (img) => img.id === image.id || img.number === image.number
        );
        if (index > -1) {
          this.route.jobImages[this.upload.type].image.splice(index, 1);
        }
      });
      this.selected = [];
      if (imagesToDelete.length > 0) {
        this.$emit("images-to-delete", {
          type: this.upload.type,
          images: imagesToDelete,
        });
      } else {
        modalSuccess(this.$bvModal, 'ลบรูปเสร็จสิ้น')
      }
      this.$bvModal.hide("upload-image");
    },
    hideModal(){
      this.selected = []
      this.$bvModal.hide("upload-image");
    }
  },
  computed:{
    checkImage(){
      return this.selected.some( item => {
        return item && item.hasOwnProperty('id')
      })
    }
  },  
  watch: {
    "upload.type": function (newValType) {
      this.selected = this.route.jobImages[newValType].selected;
    },
  },
};
</script>
